import { render, staticRenderFns } from "./mo-checkbox-wrapper.html?vue&type=template&id=bde03cd6&scoped=true&external"
import script from "./mo-checkbox-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-checkbox-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-checkbox-wrapper.scss?vue&type=style&index=0&id=bde03cd6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde03cd6",
  null
  
)

export default component.exports